import { Link } from "react-router-dom";
import VisitorCounter from "@/components/site/VisitorCounter";

export default function Footer() {
  return (
    <footer className="relative mt-12" data-testid="site-footer">
      <div className="stripe-tape h-5 w-full" />
      <div className="bg-tiger-deep px-4 py-12 text-tiger-sand">
        <div className="mx-auto grid max-w-6xl gap-10 text-center md:grid-cols-[1fr_auto] md:items-center md:text-left">
          <div>
            <div className="inline-flex items-center gap-3">
              <span className="grid h-12 w-12 place-items-center rounded-2xl border-[3px] border-tiger-sand bg-tiger-orange text-2xl">
                🐯
              </span>
              <p className="font-heading text-2xl font-bold">
                Tigersforkids.com
              </p>
            </div>
            <p className="mt-5 max-w-2xl font-body text-base leading-relaxed text-tiger-sand/80 sm:text-lg">
              Conceptualised by{" "}
              <span className="font-extrabold text-sun">Romir Mishra</span>,
              Grade 1
              <br />
              Heritage International Xperiential School, Gurugram
            </p>
            <p className="mt-6 font-body text-sm text-tiger-sand/60">
              Built with love for tigers everywhere 🌍 — Save the tigers!
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3 md:justify-start">
              <Link
                to="/game"
                className="inline-flex items-center gap-2 rounded-full border-[3px] border-tiger-sand bg-tiger-orange px-5 py-2.5 font-heading text-base font-bold text-white shadow-[6px_6px_0_#FFFDF7] hover:-translate-y-0.5 transition-transform"
                data-testid="footer-play-game"
              >
                🎮 Play the Tiger Game
              </Link>
              <Link
                to="/leaderboard"
                className="inline-flex items-center gap-2 rounded-full border-[3px] border-tiger-sand bg-sun px-5 py-2.5 font-heading text-base font-bold text-tiger-deep shadow-[6px_6px_0_#FFFDF7] hover:-translate-y-0.5 transition-transform"
                data-testid="footer-leaderboard"
              >
                🏆 Leaderboard
              </Link>
            </div>
          </div>
          <div className="md:justify-self-end">
            <VisitorCounter />
          </div>
        </div>
      </div>
    </footer>
  );
}
